import { render, staticRenderFns } from "./DragsterNeon.vue?vue&type=template&id=6fbbca97&scoped=true"
import script from "./DragsterNeon.vue?vue&type=script&lang=js"
export * from "./DragsterNeon.vue?vue&type=script&lang=js"
import style0 from "./DragsterNeon.vue?vue&type=style&index=0&id=6fbbca97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbbca97",
  null
  
)

export default component.exports